export default __webpack_public_path__ + "static/media/hiperbili_mayo2014.b4f45dd5.pdf";